import React, { useState, useRef } from 'react';

interface BlogVideoPlayerProps {
  slug: string;
}

const BlogVideoPlayer: React.FC<BlogVideoPlayerProps> = ({ slug }) => {
  const [hasError, setHasError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoSrc = `/videos/generated/blog-${slug}.mp4`;

  if (hasError) return null;

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <section className="bg-gray-50 py-12">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-primary-900">
          <video
            ref={videoRef}
            src={videoSrc}
            controls
            preload="metadata"
            className="w-full h-auto block"
            onError={() => setHasError(true)}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            style={{ aspectRatio: '16/9' }}
          >
            Your browser does not support the video tag.
          </video>

          {/* Play button overlay */}
          {!isPlaying && (
            <button
              onClick={handlePlay}
              className="absolute inset-0 flex items-center justify-center bg-primary-900/40 hover:bg-primary-900/30 transition-colors cursor-pointer group"
              aria-label="Play video"
            >
              <div className="w-20 h-20 rounded-full bg-accent-500 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                <svg className="w-8 h-8 text-primary-900 ml-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </button>
          )}
        </div>
        <p className="text-center text-sm text-gray-500 mt-4 font-medium">
          30-second video summary
        </p>
      </div>
    </section>
  );
};

export default BlogVideoPlayer;
